import templateStr from 'text!./gateway-dashboard.html';
import _ from 'lodash';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures'; // PSA


export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            selectedProducerCode: '='
        },
        controller: ['$scope', '$state', 'JobService', 'AccountService', 'gatewayParamConfig', ($scope, $state, JobService, AccountService, gatewayParamConfig) => {
            init();

            function init() {

                getAccountJobsSummaryForCurrentUser().then((summaries) => {
                    $scope.summaries = summaries;
                    filterAccountJobSummaries(summaries);
                    $scope.$emit('dashboardTilesLoaded');
                });
            $scope.gatewayEndorsementEnabled = ApplicationFeatures.getAllFeatures().gatewayendorsement === 'true'; // PSA
            $scope.gatewayCancelationEnabled_PSA = ApplicationFeatures.getAllFeatures().gatewayCancelation_PSA === 'true'; // PSA
            $scope.gatewayRenewalEnabled_PSA = ApplicationFeatures.getAllFeatures().gatewayRenewal_PSA === 'true'; // PSA
            }

            /**
             * Call PolicyCenter to retrieve the accounts jobs for the current user
             * @returns {Promise} the accounts jobs for the current user
             */
            function getAccountJobsSummaryForCurrentUser() {
                return AccountService.getAccountJobsSummariesForCurrentUser(gatewayParamConfig.jobsCreatedInLastXDays);
            }

            function filterAccountJobSummaries(summaries) {
                $scope.accountJobsSummary = _.find(summaries, (summary) => {
                    return filterSummaryByProducerCode(summary);
                });
            }

            function filterSummaryByProducerCode(summary) {
                return angular.isDefined(summary.producerCode) && summary.producerCode === $scope.selectedProducerCode.code;
            }

            $scope.$watch('selectedProducerCode', () => {
                if (angular.isDefined($scope.selectedProducerCode)) {
                    filterAccountJobSummaries($scope.summaries);
                }

            });
        }]
    };
}];
